module.exports = __webpack_public_path__ + "img/marmita-color.b9a03005.svg";